export const SUCCESS_RESPONSE = "Success"
export const FAILED_RESPONSE = "Failed"


export const ApiResponseSuccess = 1
export const APiResponseError = 0

export const ApiResponseStatusOk = 200
export const ApiResponseStatusNotFound = 400
export const ApiResponseStatusUnauthorized = 401
export const ApiResponseStatusInternalServerError = 500

export const AxiosNetworkError = "ERR_NETWORK"

export const EmptyString = ""
export const Undefined = "undefined"
export const DefaultErrorMessage = "An error has occured. Please contact IT Support"

export const FormTypeAdd = "Add"
export const FormTypeEdit = "Edit"

export const PageTypeGetPaged = "GetPaged"
export const PageTypeCount = "Count"

export const PageSize = 25

export const PaginationFirst = "First"
export const PaginationBack = "Back"
export const PaginationNext = "Next"
export const PaginationLast = "Last"

export const GuidDefault = "00000000-0000-0000-0000-000000000000"
export const DateNullDefault = "0001-01-01T00:00:00"

export const Active = "Active"
export const Deleted = "Deleted"

export const StatusCodeActive = "1"
export const StatusCodeDelete = "2"

export const DepositReceived = "Received"
export const NoDeposit = "No Deposit"

export const MdrOnUs = "OnUs"
export const MdrOffUs = "OffUs"
export const MdrQrisOnUs = "QrisOnUs"
export const MdrQrisOffUs = "QrisOffUs"

export const InsertDateFormat = "yyyy-MM-DD"

export const DropdownStatusList = [
    {label: "All", value: ""},
    {label: "Active", value: "1"},
    {label: "Delete", value: "2"}
]
export const PageSizeOptions = [
    {label: "25", value: "25"},
    {label: "50", value: "50"},
    {label: "100", value: "100"},
    {label: "All", value: "10000"},
]

export const DropdownMonthList = [
    {label: "January", value: "1"},
    {label: "February", value: "2"},
    {label: "March", value: "3"},
    {label: "April", value: "4"},
    {label: "May", value: "5"},
    {label: "June", value: "6"},
    {label: "July", value: "7"},
    {label: "August", value: "8"},
    {label: "September", value: "9"},
    {label: "October", value: "10"},
    {label: "November", value: "11"},
    {label: "December", value: "12"}
]
export const DropdownNumberOfCustomerList = [
    {label: "10", value: "10"},
    {label: "20", value: "20"},
    {label: "50", value: "50"},
    {label: "100", value: "100"}
]

export const SettlementPaymentStatusOptions = [
    {label: "All", value: ""},
    {label: "Belum Dibayar", value: "0"},
    {label: "Titipan Lunas", value: "1"},
    {label: "Tagihan Lunas", value: "2"}
]

export const DeployedYear = "2025"